import React from 'react'
import PropTypes from 'prop-types'

import Button from '../../Button/Button'

import './PromoCodeLabel.css'

export const PromoCodeLabel = ({ canSubmit, applyPromoCode, loading }) => {
  return (
    <div styleName='promoCodeLabel'>
      <Button
        data-testid='apply-promo-code-button'
        onClick={applyPromoCode}
        disabled={!canSubmit}
        loading={loading}
        style='link'
      >
          Apply
      </Button>
    </div>
  )
}

PromoCodeLabel.propTypes = {
  canSubmit: PropTypes.bool.isRequired,
  applyPromoCode: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired
}
